import { useState, type MouseEvent } from 'react';

/** Shows a record's human-readable id (INIT-007, TSK-041, …) with a copy
 *  button. Renders nothing for records that predate refs and haven't been
 *  backfilled. */
export default function RefBadge({ value }: { value?: string | null }) {
  const [copied, setCopied] = useState(false);
  if (!value) return null;

  const copy = async (e: MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      /* clipboard blocked — ignore */
    }
  };

  return (
    <span className="ref-badge" title="Record id">
      {value}
      <button type="button" className="ref-copy" onClick={copy} aria-label={`Copy ${value}`}>
        {copied ? '✓' : '⧉'}
      </button>
    </span>
  );
}
